<div class="header">
    @if (!searchBox.searchVisible) {
    <span>
        <span class="mat-title">{{ title }}</span>
    </span>
    }
    <app-search-box
        #searchBox
        backIcon="arrow_back"
        class="searchBox"
        placeholder="Buscar"
        (searchDebounce)="search($event)"
        flex
    >
    </app-search-box>
    <button mat-icon-button (click)="invalidate()">
        <mat-icon>refresh</mat-icon>
    </button>
</div>
<mat-divider></mat-divider>
<table #dataTable mat-table [dataSource]="dataSource">
    @for (col of columns; track col) {
    <ng-container [matColumnDef]="col.name">
        <th mat-header-cell *matHeaderCellDef>{{ col.label }}</th>
        <td mat-cell *matCellDef="let element">{{ element[col.name] }}</td>
    </ng-container>
    }

    <!-- <ng-content></ng-content> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
        mat-row
        class="table-row"
        (click)="onRowClick(row)"
        *matRowDef="let row; columns: displayedColumns"
    ></tr>
</table>
@if (!dataSource.hasData) {
<div class="md-padding" layout="row" layout-align="center center">
    <h3>Nenhum resultado para exibir.</h3>
</div>
}
<mat-paginator
    #pagingBar
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons
    [length]="dataSource.size"
    (page)="paginate($event)"
></mat-paginator>
